// extracted by mini-css-extract-plugin
export default {"melodyVideo":"jO-z","isFullWidth":"kO-z","landingPageVideo":"lO-z","play":"mO-z","iframeVideo":"nO-z","playHidden":"oO-z","fullwidth":"pO-z"};